package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.TacticW500Rounded: ImageVector
    get() {
        if (_tacticW500Rounded != null) {
            return _tacticW500Rounded!!
        }
        _tacticW500Rounded = Builder(name = "TacticW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(720.24f, 784.89f)
                lineToRelative(-32.17f, 32.18f)
                quadToRelative(-12.68f, 12.67f, -31.33f, 12.67f)
                reflectiveQuadToRelative(-32.33f, -13.67f)
                quadToRelative(-12.67f, -12.68f, -12.79f, -31.83f)
                quadToRelative(-0.12f, -19.15f, 12.55f, -31.83f)
                lineToRelative(31.42f, -32.17f)
                lineToRelative(-31.18f, -31.17f)
                quadToRelative(-12.67f, -12.68f, -12.67f, -31.33f)
                reflectiveQuadToRelative(12.67f, -32.33f)
                quadToRelative(13.44f, -13.67f, 32.21f, -13.79f)
                quadToRelative(18.77f, -0.12f, 32.45f, 13.55f)
                lineToRelative(31.17f, 31.18f)
                lineToRelative(31.17f, -31.94f)
                quadToRelative(12.68f, -13.67f, 31.45f, -13.67f)
                reflectiveQuadToRelative(32.44f, 13.67f)
                quadToRelative(13.68f, 13.68f, 13.56f, 32.45f)
                quadToRelative(-0.12f, 18.77f, -13.79f, 32.44f)
                lineToRelative(-30.94f, 30.94f)
                lineToRelative(31.94f, 31.93f)
                quadToRelative(13.67f, 13.68f, 13.17f, 31.95f)
                reflectiveQuadToRelative(-14.17f, 31.95f)
                quadToRelative(-13.68f, 12.67f, -31.95f, 13.05f)
                quadToRelative(-18.27f, 0.38f, -31.71f, -13.05f)
                lineToRelative(-31.17f, -31.18f)
                close()
                moveTo(263.6f, 748.86f)
                quadToRelative(10.66f, -10.66f, 10.66f, -26.23f)
                quadToRelative(0.0f, -15.56f, -10.66f, -26.23f)
                quadToRelative(-10.67f, -10.66f, -26.23f, -10.66f)
                quadToRelative(-15.57f, 0.0f, -26.23f, 10.66f)
                quadToRelative(-10.66f, 10.67f, -10.66f, 26.23f)
                quadToRelative(0.0f, 15.57f, 10.66f, 26.23f)
                reflectiveQuadToRelative(26.23f, 10.66f)
                quadToRelative(15.56f, 0.0f, 26.23f, -10.66f)
                close()
                moveTo(237.37f, 848.13f)
                quadToRelative(-52.39f, 0.0f, -88.95f, -36.55f)
                quadToRelative(-36.55f, -36.56f, -36.55f, -88.95f)
                reflectiveQuadToRelative(36.55f, -88.95f)
                quadToRelative(36.56f, -36.55f, 88.95f, -36.55f)
                quadToRelative(36.76f, 0.0f, 67.62f, 19.78f)
                quadToRelative(30.86f, 19.79f, 46.29f, 53.59f)
                quadToRelative(36.61f, -10.28f, 59.92f, -40.13f)
                quadToRelative(23.3f, -29.85f, 23.3f, -67.98f)
                verticalLineToRelative(-164.78f)
                quadToRelative(0.0f, -84.44f, 59.34f, -143.77f)
                quadToRelative(59.33f, -59.34f, 143.77f, -59.34f)
                horizontalLineToRelative(35.24f)
                lineToRelative(-26.63f, -26.63f)
                quadToRelative(-13.2f, -13.2f, -12.58f, -31.49f)
                quadToRelative(0.62f, -18.29f, 14.53f, -32.21f)
                quadToRelative(13.68f, -13.67f, 32.45f, -13.67f)
                quadToRelative(18.77f, 0.0f, 32.45f, 13.67f)
                lineToRelative(103.0f, 103.76f)
                quadToRelative(13.67f, 13.68f, 13.67f, 32.07f)
                reflectiveQuadToRelative(-13.67f, 32.07f)
                lineToRelative(-104.0f, 103.76f)
                quadToRelative(-12.68f, 12.67f, -31.57f, 12.93f)
                quadToRelative(-18.89f, 0.26f, -33.28f, -13.89f)
                quadToRelative(-13.2f, -12.44f, -13.2f, -30.99f)
                quadToRelative(0.0f, -18.55f, 12.44f, -31.75f)
                lineToRelative(26.63f, -26.63f)
                horizontalLineToRelative(-35.48f)
                quadToRelative(-46.65f, 0.0f, -79.38f, 32.73f)
                reflectiveQuadToRelative(-32.73f, 79.38f)
                verticalLineToRelative(164.78f)
                quadToRelative(0.0f, 74.2f, -47.96f, 130.29f)
                quadToRelative(-47.95f, 56.1f, -121.15f, 69.58f)
                quadToRelative(-12.72f, 38.44f, -45.53f, 62.15f)
                quadToRelative(-32.82f, 23.72f, -73.49f, 23.72f)
                close()
                moveTo(239.52f, 304.41f)
                lineTo(207.35f, 336.59f)
                quadToRelative(-12.68f, 12.67f, -31.33f, 12.67f)
                reflectiveQuadToRelative(-32.32f, -13.67f)
                quadToRelative(-12.68f, -12.68f, -12.8f, -31.83f)
                quadToRelative(-0.12f, -19.15f, 12.56f, -31.83f)
                lineToRelative(31.41f, -32.17f)
                lineToRelative(-31.17f, -31.17f)
                quadToRelative(-12.68f, -12.68f, -12.68f, -31.33f)
                reflectiveQuadToRelative(12.68f, -32.33f)
                quadToRelative(13.43f, -13.67f, 32.2f, -13.79f)
                quadToRelative(18.77f, -0.12f, 32.45f, 13.56f)
                lineToRelative(31.17f, 31.17f)
                lineToRelative(31.18f, -31.94f)
                quadToRelative(12.67f, -13.67f, 31.44f, -13.67f)
                quadToRelative(18.77f, 0.0f, 32.45f, 13.67f)
                quadToRelative(13.67f, 13.68f, 13.55f, 32.45f)
                quadToRelative(-0.12f, 18.77f, -13.79f, 32.45f)
                lineToRelative(-30.94f, 30.93f)
                lineToRelative(31.94f, 31.94f)
                quadToRelative(13.67f, 13.67f, 13.17f, 31.94f)
                quadToRelative(-0.5f, 18.27f, -14.17f, 31.95f)
                quadToRelative(-13.68f, 12.67f, -31.95f, 13.05f)
                quadToRelative(-18.27f, 0.38f, -31.7f, -13.05f)
                lineToRelative(-31.18f, -31.18f)
                close()
            }
        }
        .build()
        return _tacticW500Rounded!!
    }

private var _tacticW500Rounded: ImageVector? = null
